import AuthenticatedLayout from '@/layouts/AuthenticatedLayout'
import ClientForm from '@/components/clients/ClientForm'

export default function ClientsNew() {
  return <ClientForm />
}

ClientsNew.layout = (page: React.ReactNode) => <AuthenticatedLayout>{page}</AuthenticatedLayout>
